import React from 'react';
import { Tooltip as ToolTipComponent, TooltipProps } from 'react-bootstrap';
import './tooltip.scss';

interface CustomTooltipProps extends TooltipProps {
  tooltipText: string;
}
export default function Overlay({ tooltipText, ...props }: CustomTooltipProps) {
  return (
    <ToolTipComponent
      className="toolTipComponent"
      id="overlay-example"
      {...props}
    >
      {tooltipText}
    </ToolTipComponent>
  );
}
